import {Model} from "ords/dist/model/model";

export class RubricSurveyUser extends Model {

}

export const RubricSurveyUserConfig = {
    name: 'rubricSurveyUser',
    model: RubricSurveyUser,
    relations: [
        {name: 'user', model_name: 'user', type: 'hasOne'},
        {name: 'rubric_forms', model_name: 'rubricForm', type: 'hasMany'},
        {name: 'peers', model_name: 'rubricSurveyUserPeer', type: 'hasMany'}
    ]
}
